// extracted by mini-css-extract-plugin
module.exports = {"offices-list":"OfficesList_offices-list__12N-q","offices-list__title":"OfficesList_offices-list__title__3dmW8"};